import React, { useEffect, useState } from "react";
import axios from "../../api/axios";

// MUI components
import { Grid, Paper, Typography, MenuItem, Select, InputLabel, FormControl } from "@mui/material";

// Custom components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

function DesignationDetails() {
  const [designations, setDesignations] = useState([]);
  const [selectedId, setSelectedId] = useState("");
  const [details, setDetails] = useState(null);

  // Fetch designations on mount
  const fetchDesignations = async () => {
    try {
      const res = await axios.get("/designations");
      setDesignations(res.data);
    } catch (error) {
      console.error("Failed to fetch designations:", error);
    }
  };

  useEffect(() => {
    fetchDesignations();
  }, []);

  // Fetch designation details on change
  useEffect(() => {
    if (selectedId) {
      axios
        .post("/designation/details", { designation_id: selectedId })
        .then((res) => setDetails(res.data))
        .catch(() => setDetails(null));
    } else {
      setDetails(null);
    }
  }, [selectedId]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Grid container spacing={2} px={2} py={4}>
        <Grid item xs={12} md={6}>
          <FormControl
            fullWidth
            variant="outlined"
            sx={{
              backgroundColor: "#ffffff",
              borderRadius: 3,
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
              "& .MuiOutlinedInput-root": {
                borderRadius: 3,
                "& fieldset": {
                  borderColor: "#d0d7de",
                },
                "&:hover fieldset": {
                  borderColor: "#1976d2",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#1976d2",
                  borderWidth: "2px",
                },
              },
              mt: 1,
            }}
          >
            <InputLabel id="designation-select-label">Select Designation</InputLabel>
            <Select
              labelId="designation-select-label"
              value={selectedId}
              onChange={(e) => setSelectedId(e.target.value)}
              label="Select Designation"
              sx={{
                height: 50,
                fontSize: "1rem",
              }}
            >
              <MenuItem value="">
                <em>-- Select --</em>
              </MenuItem>
              {designations.map((item) => (
                <MenuItem key={item.id} value={item.id}>
                  {item.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        {details && (
          <Grid item xs={12}>
            <Paper
              elevation={4}
              sx={{
                p: 4,
                mt: 4,
                borderRadius: 3,
                background: "#fff",
                boxShadow: "0 8px 16px rgba(0,0,0,0.08)",
              }}
            >
              <Typography variant="h5" mb={2} color="primary">
                Designation Details
              </Typography>

              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <Typography variant="subtitle2" color="textSecondary">
                    Designation:
                  </Typography>
                  <Typography variant="body1">{details.designation_name}</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="subtitle2" color="textSecondary">
                    Cadre:
                  </Typography>
                  <Typography variant="body1">{details.cadre_name}</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="subtitle2" color="textSecondary">
                    Grade Level:
                  </Typography>
                  <Typography variant="body1">{details.grade_level}</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="subtitle2" color="textSecondary">
                    Salary Structure:
                  </Typography>
                  <Typography variant="body1">{details.salary_structure}</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="subtitle2" color="textSecondary">
                    Staff Group:
                  </Typography>
                  <Typography variant="body1">{details.staff_group}</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="subtitle2" color="textSecondary">
                    Amount(Annually):
                  </Typography>
                  <Typography variant="body1" fontWeight="bold" color="green">
                    ₦
                    {details.amount && !isNaN(details.amount)
                      ? Number(details.amount).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })
                      : "0.00"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="subtitle2" color="textSecondary">
                    Amount(Monthly):
                  </Typography>
                  <Typography variant="body1" fontWeight="bold" color="green">
                    ₦
                    {details.amount && !isNaN(details.amount)
                      ? (Number(details.amount) / 12).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })
                      : "0.00"}
                  </Typography>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        )}
      </Grid>
      <Footer />
    </DashboardLayout>
  );
}

export default DesignationDetails;
